import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {ResetConfirmationComponent} from './reset-confirmation/reset-confirmation.component';
import {RegistrationConfirmationComponent} from './registration-confirmation/registration-confirmation.component';
import {CompleteRegistrationComponent} from './complete-registration/complete-registration.component';
import {AuthGuard} from '../../core/guards/auth.guard';
import {Oauth2UserResolverService} from '../../core/services/oauth2-user.resolver.service';
import {AuthComponent} from './auth.component';
import {RegisterComponent} from './register/register.component';
import {BackgroundResolverService} from '../../core/services/background.resolver.service';
import {NoAuthGuard} from '../../core/guards/no-auth.guard';
import {InvitationComponent} from "./invitation/invitation.component";
import {OwnerChangeComponent} from "./owner-change/owner-change.component";
import {DenyInvitationComponent} from "./deny-invitation/deny-invitation.component";
import {DenyOwnerChangeComponent} from "./deny-owner-change/deny-owner-change.component";
import {CompleteRegistrationGuard} from "../../core/guards/complete-registration.guard";
import {RegistrationCheckEmailComponent} from "./registration-check-email/registration-check-email.component";

const routes: Routes = [
  {
    path: 'login', component: AuthComponent, canActivate: [NoAuthGuard],  children: [
      {path: '', component: LoginComponent},
    ],
    resolve: {
      background: BackgroundResolverService,
    }
  },
  {
    path: 'registration', component: AuthComponent, children: [
      {path: '', component: RegisterComponent, canActivate: [NoAuthGuard]},
      {path: 'check-email', component: RegistrationCheckEmailComponent, canActivate: [NoAuthGuard]},
      {path: 'confirm', component: RegistrationConfirmationComponent},
    ],
    resolve: {
      background: BackgroundResolverService,
    }
  },
  {
    path: 'reset-password', component: AuthComponent, canActivate: [NoAuthGuard], children: [
      {path: '', component: ResetPasswordComponent},
      {path: 'confirm', component: ResetConfirmationComponent},
    ],
    resolve: {
      background: BackgroundResolverService,
    }
  },
  {
    path: 'registration', component: AuthComponent, children: [
      {path: 'complete', component: CompleteRegistrationComponent, canActivate: [CompleteRegistrationGuard]},
    ],
    canActivate: [AuthGuard],
    resolve: {
      background: BackgroundResolverService,
      currentUser: Oauth2UserResolverService
    }
  },
  {
    path: 'invitation', component: AuthComponent, children: [
      {path: ':token', component: InvitationComponent},
    ],
    resolve: {
      background: BackgroundResolverService,
      currentUser: Oauth2UserResolverService
    }
  },
  {
    path: 'deny-invitation', component: AuthComponent, children: [
      {path: ':token', component: DenyInvitationComponent},
    ],
    resolve: {
      background: BackgroundResolverService
    }
  },
  {
    path: 'owner-change-confirmation', component: AuthComponent, children: [
      {path: ':token', component: OwnerChangeComponent},
    ],
    resolve: {
      background: BackgroundResolverService,
      currentUser: Oauth2UserResolverService
    }
  },
  {
    path: 'deny-change-confirmation-invitation', component: AuthComponent, children: [
      {path: ':token', component: DenyOwnerChangeComponent},
    ],
    resolve: {
      background: BackgroundResolverService
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule {
}
